import { Box, Link, Typography } from "@mui/material";
import React, { useEffect } from "react";
import DelendCentralizedCircularProgress from "../../../components/CircularProgress/DelendCentralizedCircularProgress";
import { useAppDispatch } from "../../../hooks/hooks";
import ProfileService from "../../../services/ProfileService";
import SubscriptionService from "../../../services/SubscriptionService";
import { add as addProfile } from "../../../store/profileSlice";
import { add as addSubscription } from "../../../store/subscriptionSlice";
import BusinessInformation from "./BusinessInformation/BusinessInformation";
import PersonalInformation from "./PersonalInformation/PersonalInformation";
import ReturnButton from "./ReturnButton";
import LoginSecurityInformation from "./SecurityInformation/LoginSecurityInformation";

const ProfileHeader = () => {
  return (
    <>
      <Typography variant="h2">Preferências de usuário</Typography>
      <Box>
        <Typography>
          Ao utilizar a plataforma você concorda com os{" "}
          <Link
            href={
              "https://portal.delend.com.br/static/media/termos-condicoes-uso.pdf"
            }
          >
            Termos de Uso
          </Link>{" "}
          e a{" "}
          <Link
            href={
              "https://portal.delend.com.br/static/media/politica-privacidade.pdf"
            }
          >
            Política de Privacidade.
          </Link>
        </Typography>
      </Box>
    </>
  );
};

const Profile: React.FC = () => {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);

      const [profile, subscription] = await Promise.all([
        ProfileService.getProfile(),
        SubscriptionService.getInfos(),
      ]);

      dispatch(addProfile(profile));
      dispatch(addSubscription(subscription));
      
      setLoading(false);
    };
    fetchProfile();
  }, [dispatch]);

  if (loading) return <DelendCentralizedCircularProgress />;

  return (
    <Box display={"flex"} gap={2}>
      <ReturnButton to="/dashboard" />
      <Box width={"100%"}>
        <ProfileHeader />
        <PersonalInformation />
        <LoginSecurityInformation />
        <BusinessInformation />
      </Box>
    </Box>
  );
};

export default Profile;
